import React, { useState, useEffect } from "react";
import axios from "axios";
import { Table, Button, Modal, Form } from "react-bootstrap";
import { FaEdit, FaTrash } from "react-icons/fa";
import { getItem } from "../../../services/routes.backend.services";
import constants from "../../../services/constants";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useSelector } from "react-redux";

// ✅ ReactQuill import
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const BannerListing = () => {
  // ✅ Safe Redux access
  const auth = useSelector((state) => state.auth || {});
  const token = auth?.token;
  const userRole = auth?.user?.role;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const [banners, setBanners] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editBanner, setEditBanner] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const [bannerText, setBannerText] = useState("");
  const [linkText, setLinkText] = useState("");
  const [bannerLink, setBannerLink] = useState("");
  const [bannerOrder, setBannerOrder] = useState("");
  const [bannerImage, setBannerImage] = useState(null);
  const [bannerDesc, setBannerDesc] = useState(""); // ✅ NEW

  useEffect(() => {
    fetchBanners();
  }, []);

  const fetchBanners = async () => {
    try {
      const response = await getItem("banners");
      setBanners(response?.data?.banners || []);
    } catch (error) {
      console.error("Error fetching banners:", error);
    }
  };

  const handleBannerSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("title", bannerText.trim());
    formData.append("linktext", linkText.trim());
    formData.append("link", bannerLink?.trim() || "");
    formData.append("bannerOrder", bannerOrder);
    formData.append("description", bannerDesc || ""); // ✅ NEW

    if (bannerImage) {
      formData.append("bannerImage", bannerImage);
    }

    try {
      if (editBanner) {
        await axios.put(
          `${constants.API_BASE_URL}banners/${editBanner._id}`,
          formData,
          config
        );
        toast.success("Banner updated successfully");
      } else {
        await axios.post(
          `${constants.API_BASE_URL}banners`,
          formData,
          config
        );
        toast.success("Banner created successfully");
      }

      fetchBanners();
      setShowModal(false);
      resetFormFields();
    } catch (error) {
      console.error("Error saving banner:", error);
      toast.error("Something went wrong!");
    }
  };

  const handleAdd = () => {
    setEditBanner(null);
    resetFormFields();
    setShowModal(true);
  };

  const handleEdit = (banner) => {
    setEditBanner(banner);
    setBannerText(banner?.title || "");
    setLinkText(banner?.linktext || "");
    setBannerLink(banner?.link || "");
    setBannerOrder(banner?.bannerOrder || "");
    setBannerDesc(banner?.description || ""); // ✅ NEW
    setBannerImage(null);
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this record?")) return;

    try {
      await axios.delete(
        `${constants.API_BASE_URL}banners/${id}`,
        config
      );
      toast.success("Deleted successfully");
      fetchBanners();
    } catch (error) {
      console.error("Error deleting banner:", error);
      toast.error("Delete failed!");
    }
  };

  const resetFormFields = () => {
    setBannerText("");
    setLinkText("");
    setBannerLink("");
    setBannerOrder("");
    setBannerDesc(""); // ✅ NEW
    setBannerImage(null);
  };

  return (
    <div className="container">
      <ToastContainer />

      <Button variant="primary" onClick={handleAdd}>
        Add Banner
      </Button>

      <Table striped bordered hover className="mt-3">
        <thead>
          <tr>
            <th>#</th>
            <th>Image</th>
            <th>Title</th>
            <th>Description</th>
            <th>Link</th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          {banners.length > 0 ? (
            banners.map((banner, i) => (
              <tr key={banner._id}>
                <td>{i + 1}</td>

                <td>
                  <img
                    src={`${constants.Image_BASE_URL}${banner.bannerImage}`}
                    alt={banner.title}
                    style={{ width: "100px", objectFit: "cover" }}
                  />
                </td>

                <td>{banner.title}</td>

                {/* ✅ Render HTML safely */}
                <td
                  dangerouslySetInnerHTML={{
                    __html: banner.description || "",
                  }}
                />

                <td>
                  {banner.link ? (
                    <a href={banner.link} target="_blank" rel="noreferrer">
                      Visit
                    </a>
                  ) : (
                    "-"
                  )}
                </td>

                <td>
                  <Button
                    variant="warning"
                    onClick={() => handleEdit(banner)}
                  >
                    <FaEdit />
                  </Button>

                  {userRole === "user" && (
                    <Button
                      variant="danger"
                      onClick={() => handleDelete(banner._id)}
                      className="ms-2"
                    >
                      <FaTrash />
                    </Button>
                  )}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6" className="text-center">
                No banners found
              </td>
            </tr>
          )}
        </tbody>
      </Table>

      {/* ✅ Modal */}
      <Modal show={showModal}  backdrop="static" onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            {editBanner ? "Edit Banner" : "Add Banner"}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form onSubmit={handleBannerSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Banner Image</Form.Label>
              {previewImage && (
                <div className="mb-2">
                  <img
                    src={previewImage}
                    alt="Preview"
                    style={{ width: "100px", objectFit: "cover" }}
                  />
                </div>
              )}
              <Form.Control
                type="file"
                onChange={(e) => {
                  const file = e.target.files[0];
                  setBannerImage(file);
                  if (file) {
                  setPreviewImage(URL.createObjectURL(file));
                }
              }}
            />
            </Form.Group>
<p> {/* ✅ Show existing image if editing and no new image selected */}
              {editBanner && !previewImage && (
                <img
                  src={`${constants.Image_BASE_URL}${editBanner.bannerImage}`}
                  alt={editBanner.title}
                  style={{ width: "100px", objectFit: "cover" }}
                />
              )}
            </p>  
            <Form.Group className="mb-3">
              <Form.Label>Banner Title</Form.Label>
              <Form.Control
                type="text"
                value={bannerText}
                onChange={(e) => setBannerText(e.target.value)}
                required
              />
            </Form.Group>

            {/* ✅ Description Editor */}
            <Form.Group className="mb-3">
              <Form.Label>Description</Form.Label>
              <ReactQuill
                theme="snow"
                value={bannerDesc}
                onChange={setBannerDesc}
              />
            </Form.Group>
  <Form.Group className="mb-3">
              <Form.Label>Link  Title</Form.Label>
              <Form.Control
                type="text"
                value={linkText}
                onChange={(e) => setLinkText(e.target.value)}
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Banner Link</Form.Label>
              <Form.Control
                type="text"
                value={bannerLink || ""}
                onChange={(e) => setBannerLink(e.target.value)}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Order Number</Form.Label>
              <Form.Control
                type="number"
                value={bannerOrder}
                onChange={(e) => setBannerOrder(e.target.value)}
              />
            </Form.Group>

            <Button type="submit" variant="primary" className="w-100">
              {editBanner ? "Update Banner" : "Create Banner"}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default BannerListing;